<template>
    <v-modal-slot id="expedient-detail-add-related-expedient-modal"
                  size="lg"
                  :do-close-on-accept="false"
                  @accepted="createExpedient">
        <template v-slot:modal-title>
            Crear ejecución de sentencia
        </template>

        <template v-slot:modal-content>
            <span>
                Estás intentando crear un expediente del tipo procedimiento 'Ejecución de sentencia'. Se copiarán los datos originales y relacionaremos este nuevo expediente con el actual. Este nuevo expediente pasará a llamarse
                {{ expedient.name }} - Sentencia. ¿Deseas continuar?"
            </span>
        </template>

        <template v-slot:accept-button>
            Crear
        </template>

        <template v-slot:close-button>
            Cancelar
        </template>
    </v-modal-slot>
</template>

<script>
import VModalConfirmed from "../../../general/VModalConfirmed";
import {attachExpedient, createExpedient} from "../../../../helpers/requests/RequestsExpedients";
import {storeFormValues} from "../../../../helpers/requests/RequestsFormValues";
import VModalSlot from "../../../general/VModalSlot";

export default {
    name: "ExpedientDetailAddRelatedExpedientModal",
    components: {
        VModalSlot,
        VModalConfirmed
    },
    props: {
        expedient: {
            type: Object,
            required: true,
        }
    },
    methods: {
        async createExpedient() {
            try {
                let res = await createExpedient(this.expedient.name + ' - Sentencia', this.expedient.entities[0].id, this.expedient.clients[0].id, this.expedient.contract_type, this.expedient.responsible);

                // TODO: Comprobar que los valores del formulario del nuevo expediente sean los mismos que del expediente al que se relaciona o alguno tiene qye cambiar.
                let form_values = {
                    ...this.expedient.form_values
                };

                form_values.tipo_procedimiento = 'Ejecución de sentencia';

                await storeFormValues(form_values, res.id);

                // TODO: Mirar si crear el expediente, añadir los valores del formulario y luego relacionar ambos expedientes o crear un endpoint que lo haga todo.
                await attachExpedient(this.expedient.id, res.id);

                this.$store.dispatch('app/setToastMessage', 'Expediente de ejecución de sentencia creado con éxito');

                this.$emit('created');
                this.closeModal();

            } catch (e) {
                let error_message = e.response.data.message;
                this.$store.dispatch('app/setErrorToastMessage', error_message ?? 'Error al crear el expediente de ejecución de sentencia');
            }
        },
        closeModal() {
            this.$emit('closed');
        }
    }
}
</script>
